/** Pontos de contato impressos. Precisa casar com scripts/gerar-qr.mjs. */
const ORIGENS = new Set(['cd', 'bl', 'sc', 'ft', 'mt', 'ig', 'wa'])
const CHAVE = 'du:origem'

/**
 * Captura de onde a pessoa veio.
 *
 * O QR do cardápio impresso aponta para /cd, o adesivo da sacola para /sc, e
 * assim por diante. Ao abrir, o caminho é lido, guardado na sessão e a URL é
 * LIMPA — senão o cliente compartilha o link com o código da sacola e o
 * relatório passa a contar errado.
 *
 * sessionStorage, e não localStorage: a origem vale para esta visita. Quem
 * voltar amanhã digitando o endereço não deve continuar contando como QR.
 */
export function capturarOrigem(): string | null {
  const caminho = window.location.pathname.replace(/^\/+|\/+$/g, '')
  if (ORIGENS.has(caminho)) {
    try {
      sessionStorage.setItem(CHAVE, caminho)
    } catch {
      /* navegação privada pode bloquear; a origem some, o pedido não */
    }
    window.history.replaceState({}, '', '/')
    return caminho
  }
  try {
    return sessionStorage.getItem(CHAVE)
  } catch {
    return null
  }
}

export function lerOrigem(): string | null {
  try {
    return sessionStorage.getItem(CHAVE)
  } catch {
    return null
  }
}

/** Avisa a API, uma vez por sessão. Contador agregado, sem dado pessoal. */
export async function registrarAcesso(base: string, origem: string | null): Promise<void> {
  if (!origem) return
  const JA = 'du:acesso-registrado'
  try {
    if (sessionStorage.getItem(JA)) return
    sessionStorage.setItem(JA, '1')
  } catch {
    return
  }
  try {
    await fetch(`${base}/v1/publico/acesso`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ origem }),
      // keepalive: o registro não pode segurar a navegação nem morrer se a
      // pessoa sair da página no primeiro segundo.
      keepalive: true,
    })
  } catch {
    /* contador perdido não atrapalha o pedido */
  }
}

const CHAVE_ZAP = 'du:zap'

export type ContextoZap = {
  telefone: string | null
  nome: string | null
  enderecos: {
    rua: string; numero: string; complemento: string | null
    referencia: string | null; bairroTexto: string; cep: string | null
    bairroId: string | null
  }[]
}

/**
 * Link vindo do WhatsApp: /l/<token>.
 *
 * O token é trocado pelos dados do cliente UMA vez, aqui, e a URL é limpa em
 * seguida — pelo mesmo motivo dos QR: link compartilhado com token dentro
 * entregaria o cadastro de uma pessoa a outra.
 *
 * O resultado fica em sessionStorage e não em localStorage: vale para esta
 * visita. Num celular emprestado, fechar a aba apaga.
 */
export async function capturarZap(base: string): Promise<ContextoZap | null> {
  const m = window.location.pathname.match(/^\/l\/([A-Za-z0-9_-]{10,64})\/?$/)
  if (m?.[1]) {
    window.history.replaceState({}, '', '/')
    try {
      const r = await fetch(`${base}/v1/publico/link/${m[1]}`)
      if (r.ok) {
        const ctx = (await r.json()) as ContextoZap
        try {
          sessionStorage.setItem(CHAVE_ZAP, JSON.stringify(ctx))
          sessionStorage.setItem(CHAVE, 'wa')
        } catch {
          /* navegação privada pode bloquear; o pedido continua possível */
        }
        return ctx
      }
    } catch {
      // Token vencido ou rede ruim: o cardápio abre normal e a pessoa
      // preenche à mão. Nunca uma tela de erro por causa disso.
    }
    return null
  }
  try {
    const bruto = sessionStorage.getItem(CHAVE_ZAP)
    return bruto ? (JSON.parse(bruto) as ContextoZap) : null
  } catch {
    return null
  }
}
